import { render, staticRenderFns } from "./AFTransactionsScreen.vue?vue&type=template&id=2cb44320&scoped=true&"
import script from "./AFTransactionsScreen.vue?vue&type=script&lang=js&"
export * from "./AFTransactionsScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb44320",
  null
  
)

export default component.exports